/* eslint-disable import/no-default-export */
import { SET_DEVICE_ACTIVATION_KEY } from '../actionTypes'

const urlParams = new URLSearchParams(window.location.search)
const dakFromURL = urlParams.get('dak')

const initialState = {
    deviceActivationKey: dakFromURL === null ? '' : dakFromURL
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_DEVICE_ACTIVATION_KEY: {
            const { content } = action.payload
            return {
                ...state,
                deviceActivationKey: content
            }
        }
        default:
            return state
    }
}
